import React, { useEffect, useState } from "react";
import { dict } from "../i18n";
import { fetchContent } from "../lib/api";
import SEO from "../components/SEO";
import { MapPin } from "lucide-react";

export default function Doctors({ lang }) {
  const t = dict[lang];
  const [clinic, setClinic] = useState(null);

  useEffect(() => {
    fetchContent().then(setClinic).catch(() => {});
  }, []);

  return (
    <>
      <SEO lang={lang} page="doctors" doctors={clinic?.doctors} />
      <section className="container-page pt-12 pb-8" data-testid="doctors-page">
        <div className="chip mb-3">{t.sections.doctors.tag}</div>
        <h1 className="section-title">{t.sections.doctors.title}</h1>
        <p className="text-surface-inkSoft mt-3 text-[15px] max-w-2xl">{t.sections.doctors.subtitle}</p>
      </section>

      <section className="container-page pb-20">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {(clinic?.doctors || []).map((d) => (
            <div key={d.id} className="card-clinic flex gap-5" data-testid={`doctor-detail-${d.id}`}>
              <div className="w-28 sm:w-32 shrink-0">
                <div className="aspect-[4/5] rounded-xl overflow-hidden bg-sapphire-50">
                  <img src={d.image} alt={d.name} className="w-full h-full object-cover" loading="lazy" decoding="async" width="320" height="400" />
                </div>
              </div>
              <div className="flex-1 min-w-0">
                <div className="text-[15px] font-semibold text-surface-ink">{d.name}</div>
                <div className="text-[13px] text-teal-500 font-medium uppercase tracking-wider mt-0.5">{d.role[lang]}</div>
                <div className="inline-flex items-center gap-1.5 mt-2 text-[12px] text-surface-inkSoft">
                  <MapPin className="h-3.5 w-3.5" />
                  {d.location === "tallinn" ? "Tallinn" : d.location === "tallinn-parnu" ? "Tallinn & Pärnu" : "Pärnu"} · {lang === "et" ? "alates" : lang === "ru" ? "с" : "since"} {d.since}
                </div>
                <p className="mt-3 text-[13px] text-surface-inkSoft leading-relaxed">{d.bio[lang]}</p>
              </div>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
